module.exports = __webpack_public_path__ + "img/home.81757200.png";